export default "__VITE_ASSET__nfe1AoEO__"